/** Brazilian state abbreviations (UF) */
export const ESTADOS_BR: string[] = [
  'AC','AL','AP','AM','BA','CE','DF','ES','GO','MA','MT','MS','MG',
  'PA','PB','PR','PE','PI','RJ','RN','RS','RO','RR','SC','SP','SE','TO'
];

/**
 * Returns a display string for a supplier's cities.
 * Prefers the `cidades` array (multi-city); falls back to the legacy `cidade` string.
 */
export function getCidadesDisplay(item: { cidade?: string; cidades?: any[] }): string {
  const cidades = item.cidades || [];
  if (cidades.length > 0) {
    return cidades.map((c: any) => c.nome || c.Nome || String(c)).join(', ');
  }
  return item.cidade || '—';
}

/**
 * Normalises a raw city object returned by the API, handling both
 * camelCase and PascalCase field names.
 */
export function normalizeCidade(c: any): { id: string; nome: string; estado: string; slug?: string; ativo?: boolean } {
  return {
    id: c?.id || c?.Id || c?.cidadeId || c?.CidadeId || '',
    nome: c?.nome || c?.Nome || '',
    estado: c?.estado || c?.Estado || '',
    slug: c?.slug || c?.Slug,
    ativo: c?.ativo !== false
  };
}
